import OktaAuth from '@okta/okta-auth-js';
import { environment } from '../../../environments/environment';
import { isOktaAuthRequired } from './auth-config';
import { resolveOktaUri } from './resolve-okta-uri';

/**
 * Builds the OktaAuth client when auth bypass is disabled.
 */
export function createOktaAuthClient(): OktaAuth | null {
  if (!isOktaAuthRequired()) {
    return null;
  }

  return new OktaAuth({
    issuer: environment.okta.issuer,
    clientId: environment.okta.clientId,
    redirectUri: resolveOktaUri(environment.okta.redirectUri),
    postLogoutRedirectUri: resolveOktaUri(environment.okta.postLogoutRedirectUri),
    scopes: environment.okta.scopes,
    pkce: environment.okta.pkce,
  });
}
